"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const locales = [
  "en-US",
  "nl-NL",
  "en-GB",
  "fr-FR",
  "de-DE",
  "ja-JP",
  "pt-BR",
  "es-ES",
];

const normalizePath = (path: string) => {
  const segments = path.split("/").filter(Boolean);
  return "/" + (locales.includes(segments[0]) ? segments.slice(1).join("/") : segments.join("/"));
};

export function RouteTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const currentNormalized = normalizePath(pathname);
    const prevRaw = sessionStorage.getItem("currentPath");
    const prevNormalized = prevRaw ? normalizePath(prevRaw) : null;

    if (prevNormalized !== currentNormalized) {
      sessionStorage.setItem("previousPath", prevRaw || "/");
      sessionStorage.setItem("currentPath", pathname);
    }
  }, [pathname]);

  return null;
}
